import { Fragment, h } from "preact";
import CreatorConfigMessage from "./CreatorConfigMessage";
function CreatorConfigHeader(props) {
    const { title, isRequired, error, fieldId } = props;
    return (h(Fragment, null,
        h("legend", { class: "sr-only" }, title),
        h("header", { class: "m-form__header" },
            h("h4", { class: "u-my0 u-width-auto", "aria-hidden": "true" }, title),
            h(CreatorConfigMessage, { error: error, isRequired: isRequired, fieldId: fieldId }))));
}
export default CreatorConfigHeader;
